import {
  IonModal,
  IonHeader,
  IonContent,
  IonToolbar,
  IonTitle,
} from "@ionic/react";

import closeIcon from "../../../assets/imgs/close.svg";
import { useRef, useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Capacitor } from "@capacitor/core";
import { actions } from "../../../Redux/store";
import { useSocket } from "../../../Context/SocketContext/SocketProvider";
import { getChatBotConversationHistory } from "../../../Controllers/ChatbotApi";
import ChatBotHistoryList from "./Components/ChatBotHistory/ChatBotHistoryList";

export default function ChatBotHistoryModal() {
  const { threadId } = useSocket();
  const modal = useRef<HTMLIonModalElement>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [conversationHistory, setConversationHistory] = useState<any[]>([]);

  const isOpenChatBotHistory = useSelector(
    (state: any) => state.modal.chatBotHistoryModal?.open,
  );

  // Fetch conversation history when modal is opened
  useEffect(() => {
    const fetchConversationHistory = async () => {
      if (isOpenChatBotHistory) {
        setIsLoading(true);
        try {
          const response = await getChatBotConversationHistory();
          if (response.status === 200 && response.data) {
            setConversationHistory(response.data);
          } else {
            console.error(
              "Failed to fetch conversation history:",
              response.errors,
            );
          }
        } catch (error) {
          console.error("Error fetching conversation history:", error);
        } finally {
          setIsLoading(false);
        }
      }
    };

    fetchConversationHistory();
  }, [isOpenChatBotHistory, threadId]);

  function dismiss() {
    modal.current?.dismiss();
    toggleModals();
  }

  const toggleModals = () => {
    actions.modal.closeChatBotHistoryModal(null);
  };

  return (
    <>
      <IonModal
        onDidDismiss={dismiss}
        className={`full-modal`}
        isOpen={isOpenChatBotHistory}
        backdropDismiss={false}
        ref={modal}
      >
        <IonHeader className="ion-no-border modal-ion-header">
          <IonToolbar className="custom-toolbar mt-[10px]">
            <div className="p-2 flex justify-between items-center sticky top-0 z-50">
              <div
                onClick={dismiss}
                className="flex items-center justify-center w-[32px] h-[32px] bg-white/10 rounded-full cursor-pointer"
              >
                <img
                  src={closeIcon}
                  alt="close"
                  className="w-[12.4px] h-[12.4px]"
                />
              </div>
              <IonTitle>
                <div className="flex flex-row items-center justify-center">
                  <span className="[@media(min-width:375px)]:text-[22px] text-[19px] font-medium text-white">
                    {"Chat History"}
                  </span>
                </div>
              </IonTitle>
            </div>
          </IonToolbar>
        </IonHeader>
        <IonContent>
          <ChatBotHistoryList
            isLoading={isLoading}
            conversationHistory={conversationHistory}
          />
        </IonContent>
      </IonModal>
    </>
  );
}
